import AccommodationNoticeTable from "./notice/AccommodationNoticeTable";
import AccommodationNoticeEdit from "./notice/AccommodationNoticeEdit";
import AccommodationNoticeDetail from "./notice/AccommodationNoticeDetail";
import AlertModal from "../Common/AlertModal";

import { Box, Grid, Modal } from "@mui/material";
import {
  AccommodationNoticeBox,
  AccommodationNoticeIcon,
  AccommodationRightBoxSideColor,
  AccommodationRightBoxTitle,
  NoticeTitleBox,
  NoticeTitleSpanBox,
} from "../../styles/accommodationStyle";
import { useCallback, useEffect, useState } from "react";
import { ModalStyle } from "../../styles/theme";
import { ModalState } from "../../system/Constants";
import { NoticeData } from "../../system/types/Notice";
import { NoticeApi } from "../../system/api/NoticeApi";
import { InitNoticeDetailData } from "../../system/types/initObject";
import { ErrorHandler } from "../../system/ApiService";

function AccommodationNotice() {
  const [modalOpen, setModalOpen] = useState(false);
  // state 분류 - table, edit, detail
  const [noticeState, setNoticeState] = useState(ModalState.table);
  const [mainNoticeData, setMainNoticeData] =
    useState<NoticeData>(InitNoticeDetailData);
  const [selectedNotice, setSelectedNotice] =
    useState<NoticeData>(InitNoticeDetailData);
  const [noticeData, setNoticeData] = useState<NoticeData[]>([]);
  const [pageNumber, setPageNumber] = useState<number>(0);
  const [totalPage, setTotalPage] = useState(1);
  const handleClose = () => {
    setModalOpen(false);
    setNoticeState(ModalState.table);
  };

  const getNoticeData = useCallback(() => {
    NoticeApi.getNoticeData("휴양소", pageNumber, 10)
      .then((res) => {
        setNoticeData(res.data.notice);
        setTotalPage(res.data.totalPages);
      })
      .catch((err) => {
        let msg = ErrorHandler(err);
        AlertModal("msg", msg);
      });
  }, [pageNumber]);

  const getMainNotice = useCallback(() => {
    const ComparedTodayDate = new Date();
    NoticeApi.getNoticeData("휴양소", 0, 1)
      .then((res) => {
        if (
          res.data.notice.length > 0 &&
          res.data.notice[0].mainStartDate &&
          new Date(res.data.notice[0].mainStartDate) < ComparedTodayDate &&
          (res.data.notice[0].mainEndDate === null ||
            new Date(res.data.notice[0].mainEndDate) > ComparedTodayDate)
        ) {
          setMainNoticeData(res.data.notice[0]);
        }
      })
      .catch((err) => {
        let msg = ErrorHandler(err);
        AlertModal("msg", msg);
      });
  }, []);

  const openMainNoticeModal = () => {
    setModalOpen(true);
    setNoticeState(ModalState.detail);
    setSelectedNotice(mainNoticeData);
  };

  useEffect(() => {
    getMainNotice();
  }, []);

  useEffect(() => {
    getNoticeData();
  }, [pageNumber]);

  return (
    <AccommodationNoticeBox
      container
      item
      xs={12}
      justifyContent="space-between"
      alignItems="center"
    >
      <Grid container item xs={10}>
        <AccommodationRightBoxTitle item>공지사항</AccommodationRightBoxTitle>

        {mainNoticeData.title === "" ? (
          "등록된 주요 공지사항이 없습니다."
        ) : (
          <NoticeTitleBox
            item
            xs
            style={{
              cursor: "pointer",
              overflow: "hidden",
              whiteSpace: "nowrap",
              textOverflow: "ellipsis",
              display: "flex",
              alignItems: "center",
            }}
            onClick={openMainNoticeModal}
          >
            <AccommodationNoticeIcon
              src="/images/VEHICLE/mainSpeaker.png"
              alt="주요 공지사항"
            />
            <NoticeTitleSpanBox>{mainNoticeData.title}</NoticeTitleSpanBox>
          </NoticeTitleBox>
        )}
      </Grid>

      <AccommodationRightBoxSideColor
        item
        xs={2}
        onClick={() => {
          setModalOpen(true);
          setPageNumber(0);
        }}
      >
        전체보기
      </AccommodationRightBoxSideColor>
      <Modal
        open={modalOpen}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={ModalStyle}>
          {noticeState === ModalState.table && (
            <AccommodationNoticeTable
              setSelectedNotice={setSelectedNotice}
              setNoticeState={setNoticeState}
              handleClose={handleClose}
              pageNumber={pageNumber}
              setPageNumber={setPageNumber}
              noticeData={noticeData}
              totalPage={totalPage}
            />
          )}
          {noticeState === ModalState.edit && (
            <AccommodationNoticeEdit
              handleClose={handleClose}
              selectedNotice={selectedNotice}
              setNoticeState={setNoticeState}
              getNoticeData={getNoticeData}
              setPageNumber={setPageNumber}
            />
          )}
          {noticeState === ModalState.detail && (
            <AccommodationNoticeDetail
              handleClose={handleClose}
              selectedNotice={selectedNotice}
              setNoticeState={setNoticeState}
            />
          )}
        </Box>
      </Modal>
    </AccommodationNoticeBox>
  );
}

export default AccommodationNotice;
